import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import { Input } from "antd"
import { CustomerServiceOutlined, CloseOutlined, SendOutlined, AliwangwangOutlined } from "@ant-design/icons";
import './index.less'
import jiqiren from 'static/img/jiqiren.gif'
import kehu from 'static/img/kehu.png'
import { request, dsAiUrl } from "utils.js";

const UserInputMsg = (props) => {
  const {msg} = props
  return (
    <div className='aiCon customer'>
      <div className='aiCon-box'>
        {msg}
      </div>
      <div className='aiCon-icon'><span><img src={kehu} /></span></div>
    </div>
  )
}
const AnsMsg = (props) => {
  const {ansMsg} = props
  return (
    <div className='aiCon aiprt'>
      <div className='aiCon-icon'><span><img src={jiqiren} /></span></div>
      <div className='aiCon-box'>
        {ansMsg}
      </div>
    </div>
  )
}
const InputMsg = (props) => {
  const {msg, setMsg, sendMsg} = props
  return (
    <div className='inputBox'>
      <Input placeholder="您可以尝试输入“政策法规”等进行提问"
             onChange={(e) => {
               setMsg(e.target.value)
             }}
             value={msg}
             onKeyDown={(e) => {
               if (e.key === 'Enter') {
                 sendMsg()
               }
             }}
      />
      <span className='aiSendButton'><SendOutlined onClick={sendMsg} /></span>
    </div>
  )
}
// let element = document.getElementByClassName('aiprtAnswer');
//  element[0].focus();
let curId = ''
export default function Online() {
  const [aiShow, setAiShow] = useState(false)
  const myref = useRef(null);
  const sideBox = useRef(100)
  const scrolBottom = () => {
    myref.current?.scrollIntoView({behavior: "smooth"})
  }

  // console.log(sideBox.current?.scrollHeight,222222)

  // 消息列表
  const [msgCmpList, setMsgCmpList] = useState([
    // {
    // 	id: -1,
    //   role: 'user',
    //   content: '你好'
    // },
    // {
    // 	id: -2,
    //   role: 'assistant',
    //   content: '你好，有什么可以 规定。fgdfg 2. **《深圳市政府采购管理办法》**：该办法对深圳市政府采购的组织实施、采购程序、合同管理、监督检查等方面进行了详细规定。 3. **《深圳市政府采购电子化管理办法》**：随着信息技术的发展，深圳市政府采购逐步推行电子化，该办法对电子化采购的管理进行了规范。 4. **《深圳市政府采购供应商管理办法》**：对参与深圳市政府采购的供应商的注册、管理、评价等进行了规定。 5. **《深圳市政府采购评审专家管理办法》**：对政府采购评审专家的资格认定、管理、使用等进行了规范。 6. **《深圳市政府采购合同管理办法》**：对政府采购合同的签订、履行、变更、解除等进行了规定。 7. **《深圳市政府采购监督管理办法》**：对政府采购活动的监督、检查、投诉处理等进行了规定。 8. **《深圳市政府采购信息公开管理办法》**：对政府采购信息的公开范围、方式、时限等进行了规定。 这些法规和规范性文件共同构成了深圳市政府采购的法规框架，旨在确保政府采购活动的公开、公平、公正，提高财政资金的使用效率，防止腐败行为的发生。具体的法规内容可能会随着法律法规的更新和政策的调整而变化，因此在实际操作中应以最新发布的法规为准'
    // },

  ])
  const [msg, setMsg] = useState('')
  const sendMsg = async () => {
    if (!msg) return;
    const ansId = Date.now()
    // 新增一个提问组件
    setMsgCmpList(prevState => [...prevState, {
      id: 'que-' + ansId,
      role: 'user',
      content: msg
    }])			// 新加一个回答组件，并初始化
    setMsgCmpList(prevState => [...prevState, {
      id: 'ans-' + ansId,
      role: 'assistant',
      content: '正在思考中...'
    }])
    setMsg('') // 清空输入框
    // 走接口
    try {
      // Simulate API call to get response using stream mode
      const response = await fetch(dsAiUrl + '/chat/stream', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Token': curId
        },
        body: JSON.stringify({msg: msg})
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const reader = response.body.getReader();
      const decoder = new TextDecoder('utf-8');

      while (true) {
        const {done, value} = await reader.read();
        if (done) break;
        let v = decoder.decode(value, {stream: true});
        // todo 这个输出是Markdown格式，需要解析成HTML，但不能在循环里面吧，要不就乱了
        // el.innerHTML += marked.parse(v);
        // el.innerHTML += v; // 直接输出了markdown格式
        // setAnwMsg(prevState => prevState + v)
        // vvv+=v // 读取所有数据
        setMsgCmpList(prevState => {
          const newCmpList = [...prevState];
          newCmpList[newCmpList.length - 1].content += v;
          return newCmpList;
        })
      }
    } catch (error) {
      console.error("Error fetching response:", error);
    }
  }
  useEffect(() => {
    scrolBottom()
  }, [msgCmpList])
  const clickShow = async () => {
    setAiShow(!aiShow)
    // 初始化用户信息
    let initRes = await fetch(dsAiUrl + '/init', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (!initRes.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    initRes.json().then(res => {
      const {data} = res;
      curId = data;
    }).catch(err => {
      console.error('初始化异常', err);
    })
  }
  return (
    <>
      <div className="online">
        <span className="online-icon"><Link to="/help" target="_blank"><CustomerServiceOutlined /></Link></span>
        <div className="online-con">
          <div className="online-con-phone">
            <h5><CustomerServiceOutlined />服务与咨询</h5>
            <span>请您根据实际情况联系服务人员，以便我们快速为您解决问题</span>
          </div>
          <div className="online-con-text"><Link to="/help" target="_blank">{'查看更多联系、反馈方式 >'}</Link></div>
        </div>
      </div>

      <div className="intelligence">
        <span className="intelligence-icon" onClick={clickShow}><AliwangwangOutlined /></span>
        {aiShow ? (<div className="intelligence-con">
          <div className="aiprtAnswer">
            <div className='aiprtTips'>
              <img alt="数智采Ai" src={jiqiren} width={24} height={24} />Hi，我是数智采智能机器人，很高兴为您服务。
            </div>
            <div ref={sideBox}>
              {msgCmpList?.map((item, index) => {
                if (item.role === 'user') {
                  return <UserInputMsg msg={item.content} key={item.id} />
                } else if (item.role === 'assistant') {
                  return <AnsMsg ansMsg={item.content} key={item.id} />
                }
              })}
            </div>
            {/*用户输入*/}
            {/*回答*/}
            {/*用户输入*/}
            {/*回答*/}
            <div ref={myref}></div>
          </div>
          <InputMsg msg={msg} setMsg={setMsg} sendMsg={sendMsg} />
        </div>) : ''}

      </div>
    </>
  );
}
